module.exports = __webpack_public_path__ + "img/lykzb1.4eba2d5a.jpg";